// extracted by mini-css-extract-plugin
module.exports = {"portal":"styles__portal__2Y6aI","wrapper":"styles__wrapper__3xOkS","btn-close":"styles__btn-close__2G_OP","btnClose":"styles__btn-close__2G_OP"};